import React from 'react'
import {
  Create,
  LongTextInput,
  SimpleForm,
  TextInput
} from 'react-admin';


export const LayerCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="label" />
      <TextInput source="authId" />
      <LongTextInput source="url" />
    </SimpleForm>
  </Create>
);

export default LayerCreate



// WEBPACK FOOTER //
// ./src/components/LayerCreate.js